// extracted by mini-css-extract-plugin
module.exports = {"calloutContainer":"HowBusyIsAbout-module--calloutContainer--3OlSd","calloutText":"HowBusyIsAbout-module--calloutText--qvOH0"};